import { useParams } from "react-router";
import {
  BreadCrumb,
  ApiLoadingSpinner,
  ApiUpdatingSpinner,
  Button,
  Header,
} from "@funcional/react-ui";
import { Restricted } from "@funcional/react-auth-ui";
import {
  AuthenticationExternalApiCard,
  RegistrationPolicyCard,
} from "@pbm/registration-policies/components";
import { useRegistrationPolicy } from "@pbm/registration-policies/hooks";
import { useFindAuthenticationExternalApi } from "@pbm/registration-policies/hooks/useFindAuthenticationExternalApi";

export default function ViewRegistrationPolicyPage() {
  let { registrationPolicyId }: { registrationPolicyId: string } = useParams();
  const {
    status: statusPolicy,
    data: dataPolice,
    error: errorPolicy,
    isFetching: isFetchingPolice,
  } = useRegistrationPolicy(registrationPolicyId);

  const {
    status: ExternalApiStatus,
    data: ExternalApiData,
    error: ExternalApiError,
    isFetching: isFetchingExternalApi,
  } = useFindAuthenticationExternalApi(Number(registrationPolicyId));

  return (
    <>
      <Header
        title={`Política Cadastral #${registrationPolicyId}`}
        backTo="/pbm/registration-policies"
        buttons={
          <Restricted to="create.registration-policies">
            <div className="flex-shrink-0 mb-8">
              <Button
                color="primary"
                href={`/pbm/registration-policies/${registrationPolicyId}/edit`}
              >
                Editar
              </Button>
            </div>
          </Restricted>
        }
      >
        <BreadCrumb
          marginBottom={0}
          items={[
            {
              path: "/pbm/registration-policies",
              label: "Políticas Cadastrais",
            },
            { label: `#${registrationPolicyId}` },
          ]}
        />
      </Header>

      {statusPolicy === "loading" ? (
        <ApiLoadingSpinner />
      ) : statusPolicy === "error" ? (
        <span className="text-sm text-red-500">
          Erro: {JSON.stringify(errorPolicy)}
        </span>
      ) : (
        <>
          {dataPolice ? (
            <RegistrationPolicyCard registrationPolicy={dataPolice} />
          ) : (
            <p>Política cadastral não encontrada.</p>
          )}
          {isFetchingPolice ? <ApiUpdatingSpinner /> : null}
        </>
      )}

      {ExternalApiStatus === "loading" ? <ApiLoadingSpinner /> : null}

      {ExternalApiStatus === "error" ? (
        <span className="text-sm text-red-500">
          Erro: {JSON.stringify(ExternalApiError)}
        </span>
      ) : null}

      {isFetchingExternalApi ? <ApiUpdatingSpinner /> : null}

      {ExternalApiData ? (
        <AuthenticationExternalApiCard
          authenticationExternalApi={ExternalApiData.authenticationExternalApi}
        />
      ) : null}
    </>
  );
}
